import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_START_STRONG = defineFcm('starter_experience_dashboard_start_strong')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_start_strong',
		enabled: false,
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard',
		description:
			'Controls the visibility of the Start Strong guided flow on the starter dashboard — a full-screen, step-by-step experience that walks petition starters through a few early tasks on their first day to set them up for success.',
		import: false,
		template: {
			experimentName: 'starter_experience_start_strong',
			enabled: false,
		},
	});
